/** @format */

import React, { useState } from "react";
import ModalWrapper from "../../../shared/components/ModalWrapper";
import {
  UBER_AUTH_CLIENT_ID,
  UBER_AUTH_RESPONSE_TYPE,
  UBER_AUTH_REDIRECT_PATH,
} from "../../../config/config";
import { downloadTOBA, uberDriverTerms } from "../../../shared/utils/apiUtils";
import { useNavigate } from "fusion-plugin-react-router";

const TqGetQuoteModal = ({ onClose }) => {
  const navigate = useNavigate();
  const [termsAccepted, setTermsAccepted] = useState(false);
  const [error, setError] = useState("");

  const handleCheckboxChange = (e) => {
    setTermsAccepted(e.target.checked);
    if (e.target.checked) setError("");
  };

  const handleButtonClick = () => {
    if (!termsAccepted) {
      setError(
        "You cannot obtain a quote without confirming acceptance of the Uber Driver Terms for Insurance Arrangements."
      );
      return;
    }
    setError("");
    window.location.href = `https://login.uber.com/oauth/v2/authorize?client_id=${UBER_AUTH_CLIENT_ID}&response_type=${UBER_AUTH_RESPONSE_TYPE}&redirect_uri=${window
      .location.origin + UBER_AUTH_REDIRECT_PATH}`;
  };

  return (
    <ModalWrapper
      heading="User agreement"
      simpleText={
        <>
          By logging into your Uber account your driver data will be shared with
          ourselves and used to provide you with a quotation. You must check
          this data to ensure it is accurate and update where necessary. It is
          your duty to make a fair representation of the risk. This means you
          must describe your business accurately and disclose every material
          fact or circumstance known to you or to anyone who is responsible for
          your insurance. Please see our{" "}
          <a
            href="#"
            onClick={(e) => {
              e.preventDefault();
              downloadTOBA({ navigate });
            }}
            className="transparentButton"
          >
            Terms of Business
          </a>{" "}
          for further information.
        </>
      }
      buttonText="Proceed"
      showClose={true}
      onClose={onClose}
      onButtonClick={handleButtonClick}
      showCheckbox={true}
      checkboxLabel={
        <>
          I have read and understood the{" "}
          <a
            href="#"
            onClick={(e) => {
              e.preventDefault();
              uberDriverTerms({ navigate });
            }}
            className="transparentButton"
          >
            Uber Driver Terms for Insurance Arrangements
          </a>
          .
        </>
      }
      checkboxChecked={termsAccepted}
      checkboxError={error}
      onCheckboxChange={handleCheckboxChange}
    />
  );
};

export default TqGetQuoteModal;
